import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/relatorio')({
  component: RelatorioLayout,
});

function RelatorioLayout() {
  return <Outlet />;
}
